<template>
	<div id="map_container">
		<!-- <v-overlay opacity="0.5" z-index="1" absolute>
        <v-progress-circular
          indeterminate
          color="primary"
          size="150"
          width="10"
        ></v-progress-circular>
		</v-overlay>-->
		<div id="map"></div>
	</div>
</template>

<script>
import { init } from "@/utils/gmaps.js";
import chroma from "chroma-js";
import { humanFileSize } from '@/utils/index.js';

export default {
	props: {
		center: { type: Object, default: { lat: 40.4165, lng: -3.70256 } },
		zoom: Number,
		value: Array,
		marker: Boolean,
		noEdit: Boolean,
		noDraw: Boolean
	},
	data() {
		return {
			google: null,
			map: null,
			drawingControl: null,
			activeDrawingMode: null,
			drawingPath: [],
			drawingPolygon: null,
			drawingColor: null,
			mapClickListener: null,
			mapRightClickListener: null,
			prevMarker: null,
			// cubiertas: JSON.parse(JSON.stringify(this.cub)),
		};
	},
	computed: {
		cubiertas() {
			return this.value;
		},
	},
	async mounted() {
		if (this.google == null) {
			this.google = await init();
		}
		await this.$nextTick();
		const map = new this.google.maps.Map(this.$el.querySelector('#map'), {
			center: this.center,
			zoom: this.zoom,
			mapTypeId: "hybrid",
		});
		this.map = map;
		this.map.setTilt(0);

		if (this.marker) {
			this.prevMarker = new this.google.maps.Marker({
				position: this.center,
				map: this.map,
				title: "Marcardor suministro",
			});
		}
		this.cubiertas.splice(0, 0);

		if (this.noEdit) return;
		this.createDrawingControl();
		this.setDrawingMode(!this.noDraw ? "polygon" : "marker");
	},
	beforeDestroy() {
		this.clearDrawingListeners();
		if (this.drawingPolygon) this.drawingPolygon.setMap(null);
	},
	methods: {
		panTo(coord) {
			this.map.panTo(coord)
		},
		humanFileSize,
		async buscarDireccion(dir) {
			const geocoder = new this.google.maps.Geocoder();
			let coords = await geocoder.geocode({ address: dir })
			coords = coords.results[0].geometry.location
			return { lat: coords.lat(), lng: coords.lng() }
		},
		createDrawingControl() {
			const control = document.createElement("div");
			control.className = "map-drawing-control";

			if (!this.noDraw) {
				const polygonButton = this.createDrawingButton("Cubierta", "polygon");
				control.appendChild(polygonButton);
			}

			const markerButton = this.createDrawingButton("Marcador", "marker");
			control.appendChild(markerButton);

			if (!this.noDraw) {
				const finishButton = this.createDrawingButton("Finalizar", "finish");
				const cancelButton = this.createDrawingButton("Cancelar", "cancel");
				control.appendChild(finishButton);
				control.appendChild(cancelButton);
			}

			this.drawingControl = control;
			this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(control);
			this.updateDrawingControl();
		},
		createDrawingButton(label, action) {
			const button = document.createElement("button");
			button.type = "button";
			button.textContent = label;
			button.dataset.action = action;
			button.addEventListener("click", (event) => {
				event.preventDefault();
				event.stopPropagation();

				if (action == "finish") {
					this.finishPolygon();
					return;
				}

				if (action == "cancel") {
					this.cancelPolygon();
					return;
				}

				this.setDrawingMode(action);
			});
			return button;
		},
		updateDrawingControl() {
			if (!this.drawingControl) return;

			this.drawingControl.querySelectorAll("button").forEach((button) => {
				const action = button.dataset.action;
				button.classList.toggle("active", action == this.activeDrawingMode);
				button.disabled = action == "finish" && this.drawingPath.length < 3;
				button.style.display =
					["finish", "cancel"].includes(action) && this.activeDrawingMode != "polygon"
						? "none"
						: "";
			});
		},
		setDrawingMode(mode) {
			if (this.activeDrawingMode == mode) return;

			this.clearDrawingListeners();
			if (this.drawingPolygon) {
				this.drawingPolygon.setMap(null);
				this.drawingPolygon = null;
			}
			this.drawingPath = [];
			this.activeDrawingMode = mode;
			this.map.setOptions({ draggableCursor: mode ? "crosshair" : null });

			if (mode == "polygon") this.startPolygonDrawing();
			if (mode == "marker") this.startMarkerDrawing();

			this.updateDrawingControl();
		},
		clearDrawingListeners() {
			if (this.mapClickListener) {
				this.google.maps.event.removeListener(this.mapClickListener);
				this.mapClickListener = null;
			}

			if (this.mapRightClickListener) {
				this.google.maps.event.removeListener(this.mapRightClickListener);
				this.mapRightClickListener = null;
			}
		},
		startPolygonDrawing() {
			this.drawingColor = chroma.random().toString();
			this.drawingPolygon = new this.google.maps.Polygon({
				paths: [],
				editable: false,
				clickable: false,
				strokeColor: this.drawingColor,
				fillColor: this.drawingColor,
				map: this.map,
			});

			this.mapClickListener = this.google.maps.event.addListener(
				this.map,
				"click",
				(event) => this.addPolygonPoint(event.latLng)
			);

			this.mapRightClickListener = this.google.maps.event.addListener(
				this.map,
				"rightclick",
				() => this.finishPolygon()
			);
		},
		addPolygonPoint(latLng) {
			this.drawingPath.push(latLng);
			this.drawingPolygon.setPath(this.drawingPath);
			this.updateDrawingControl();
		},
		finishPolygon() {
			if (this.activeDrawingMode != "polygon" || this.drawingPath.length < 3) return;

			const path = [...this.drawingPath];
			const finalPolygon = new this.google.maps.Polygon({
				paths: path,
				editable: false,
				clickable: false,
				strokeColor: this.drawingColor,
				fillColor: this.drawingColor,
				map: this.map,
			});
			finalPolygon.visible = true;
			const area = parseFloat(
				this.google.maps.geometry.spherical.computeArea(path)
			).toFixed(3) + " m2";

			const center = path.map((p) => [p.lat(), p.lng()]);
			const x = center.map((xy) => xy[0]);
			const y = center.map((xy) => xy[1]);
			const cx = (Math.min(...x) + Math.max(...x)) / 2;
			const cy = (Math.min(...y) + Math.max(...y)) / 2;

			this.cubiertas.push({
				color: this.drawingColor,
				polygon: finalPolygon,
				nombre: `Cubierta ${this.cubiertas.length + 1}`,
				center: { lat: cx, lng: cy },
				area,
				id: Math.random(),
			});

			if (this.drawingPolygon) {
				this.drawingPolygon.setMap(null);
				this.drawingPolygon = null;
			}
			this.drawingPath = [];
			this.clearDrawingListeners();
			this.startPolygonDrawing();
			this.updateDrawingControl();
		},
		cancelPolygon() {
			if (this.drawingPolygon) {
				this.drawingPolygon.setMap(null);
				this.drawingPolygon = null;
			}
			this.drawingPath = [];
			if (this.activeDrawingMode == "polygon") {
				this.clearDrawingListeners();
				this.startPolygonDrawing();
			}
			this.updateDrawingControl();
		},
		startMarkerDrawing() {
			this.mapClickListener = this.google.maps.event.addListener(
				this.map,
				"click",
				(event) => {
					const marker = new this.google.maps.Marker({
						position: event.latLng,
						map: this.map,
					});
					const pos = {
						latitud: event.latLng.lat(),
						longitud: event.latLng.lng(),
					};
					this.$emit("changePosition", pos);

					if (this.prevMarker) this.prevMarker.setMap(null);
					this.prevMarker = marker;
				}
			);
		},
	},
	watch: {
		center: {
			handler(n) {
				try {
					this.map.panTo(n);
				} catch { }
			},
			deep: true,
		},
		zoom: {
			handler(n) {
				try {
					this.map.setZoom(n);
				} catch { }
			},
			deep: true,
		},
		cubiertas: {
			handler(newVal) {
				newVal.forEach((p) => {
					if (Array.isArray(p.polygon)) {
						p.polygon = new this.google.maps.Polygon({
							paths: p.polygon,
							strokeColor: p.color,
							fillColor: p.color,
						});
					}
					if (p.polygon.visible == null) p.polygon.visible = true;
					p.polygon.setMap(this.map);
				});
			},
			immediate: false,
		},
		// cubiertas(newVal) {
		// 	this.drawingManager.setMap(null);
		// 	this.drawingManager = this.getDrawingManager();
		// 	// this.drawingManager.setMap(this.map);

		// 	newVal.forEach((polygon) => {
		// 		console.log(polygon.polygon.visible);
		// 		// polygon.polygon.setMap(this.map);
		// 	});
		// 	this.$emit(
		// 		"input",
		// 		newVal.filter((item) => item.polygon.visible)
		// 	);
		// },
	},
};
</script>

<style lang="scss" scoped>
#map_container {
	height: 100%;
	#map {
		height: 100%;
	}
}

::v-deep .map-drawing-control {
	display: flex;
	gap: 4px;
	margin-top: 10px;
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
	overflow: hidden;

	button {
		height: 32px;
		border: 0;
		border-right: 1px solid #ddd;
		background: #fff;
		color: #333;
		font: 500 13px Roboto, Arial, sans-serif;
		padding: 0 10px;
		cursor: pointer;

		&:last-child {
			border-right: 0;
		}

		&.active {
			background: #e8f0fe;
			color: #1967d2;
		}

		&:disabled {
			color: #999;
			cursor: default;
		}
	}
}
</style>
